import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFView = _resolveComponent("PDFView")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_ctx.pdfSource)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        class: "elevation-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PDFView, {
            class: "elevation-16",
            source: _ctx.pdfSource,
            page: _ctx.currentPage
          }, null, 8, ["source", "page"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}